import { applicationModuleRegistry } from '@philips-internal/oswald-ui-foundation';
import { ApplicationRoute } from '../../constants/routes';
 
export function setupMealDelivery(): void {
  applicationModuleRegistry.register({
    entry: 'MEAL_DELIVERY#9141',
    id: 'MEAL_DELIVERY#9141',
    name: 'module.meal-delivery',
    route: `${ApplicationRoute.MEAL_DELIVERY}${ApplicationRoute.SEARCH_PATIENT_MEAL_DELIVERY}`
  });
}